import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import {Router} from '@angular/router';
import {ServiceConfig} from './service-config';
import {HttpClient} from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
@Injectable()
export class CommentService {

  private host = ServiceConfig.host;
  private baseUrl = this.host + '/api/comment/';
  // public baseUrl = 'http://localhost/api/department/';
  
  private data: any;
  private headers: Headers;
  private options: RequestOptions;

  constructor(private http: Http,
              private httpClient: HttpClient,
              private router: Router,private toastrService: ToastrService) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    this.headers = new Headers({
      'Content-Type': 'application/json'
    });
    this.options = new RequestOptions({headers: this.headers});
  }


  private processResponse(res: any, url: string) {
    console.log('BACKEND POST ' + url);
    console.log(res.message);
    if(res.processAccount){
      let account = localStorage.getItem('currentSmmAccount') !== undefined && localStorage.getItem('currentSmmAccount') !== 'undefined' ? JSON.parse(localStorage.getItem('currentSmmAccount')) : {};
      if(account.username!=res.processAccount){
        this.toastrService.error("Bình luận đang được xử lý bởi "+res.processAccount+" !","Thông báo!");
      }
    }
  }

  public index(body) {
    let url = this.baseUrl + '?token=' + this.data.token;
    // console.log(url);
    return this.httpClient.post<any>(url, body);
  }
  public countCommentHistory() {
    let url = this.baseUrl + 'countHistoryComment?token=' + this.data.token;
    // console.log(url);
    return this.httpClient.get<any>(url);
  }


  public create(body) {
    let url = this.baseUrl + 'create?token=' + this.data.token;
    // console.log(url);
    return this.httpClient.post<any>(url, body);
  }

  public delete(body) {
    let url = this.baseUrl + 'delete?token=' + this.data.token;
    // console.log(url);
    return this.httpClient.post<any>(url, body);
  }

  public updateCmt(body) {
    let url = this.baseUrl + 'update?token=' + this.data.token;
    // console.log(url);
    return this.httpClient.post<any>(url, body);
  }
  
  public addNew(comment) {
    let url = this.baseUrl + 'add?token=' + this.data.token;

    this.httpClient.post<any>(url, comment._source)
      .subscribe(
        res => {
          this.processResponse(res, url);
            comment._source.isRead = 1;
            comment._source.isProcessed = 1;
        }
      );
  }
  
  public update(comment, callback = undefined) {
    let url = this.baseUrl + 'updateStatus?token=' + this.data.token;

    this.httpClient.post<any>(url, comment)
      .subscribe(
        res => {
          this.processResponse(res, url);
          callback();
        }
      );
  }

  public updateBatch(comment, callback = undefined) {
    let url = this.baseUrl + 'updateStatusBatch?token=' + this.data.token;

    this.httpClient.post<any>(url, comment)
      .subscribe(
        res => {
          this.processResponse(res, url);
          callback();
        }
      );
  }

  public updateCommentSentiment(body){
    let url = this.baseUrl + 'updateCommentSentiment?token=' + this.data.token;   
    return this.httpClient.post<any>(url, body); 
  }

  public getCommentId(body) {
    let url = this.host + '/api/FBPriority/getCommentId?token=' + this.data.token;
    return this.httpClient.post<any>(url, body); 
  }
  
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_services/comment.service.ts